import LicenseCard from './component'

export default LicenseCard
